import React from "react";

const PBadge = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="17"
      viewBox="0 0 22 17"
      fill="none"
    >
      <rect y="0.75" width="22" height="16" rx="8" fill="#FFE8BB" />
      <path
        d="M7.68066 5.3252C8.26367 5.3252 8.74414 5.39551 9.12207 5.53613C9.50293 5.67676 9.78564 5.88916 9.97021 6.17334C10.1548 6.45752 10.2471 6.81641 10.2471 7.25C10.2471 7.54297 10.1914 7.79932 10.0801 8.01904C9.96875 8.23877 9.82227 8.4248 9.64062 8.57715C9.45898 8.72949 9.2627 8.854 9.05176 8.95068L10.9414 11.75H9.42969L7.896 9.28467H7.1709V11.75H5.80859V5.3252H7.68066ZM7.58398 6.44141H7.1709V8.17725H7.61035C8.06152 8.17725 8.38379 8.10254 8.57715 7.95312C8.77344 7.80078 8.87158 7.57812 8.87158 7.28516C8.87158 6.98047 8.76611 6.76367 8.55518 6.63477C8.34717 6.50586 8.02344 6.44141 7.58398 6.44141ZM13.6221 5.3252C14.2051 5.3252 14.6855 5.39551 15.0635 5.53613C15.4443 5.67676 15.7271 5.88916 15.9116 6.17334C16.0962 6.45752 16.1885 6.81641 16.1885 7.25C16.1885 7.54297 16.1328 7.79932 16.0215 8.01904C15.9102 8.23877 15.7637 8.4248 15.582 8.57715C15.4004 8.72949 15.2041 8.854 14.9932 8.95068L16.8828 11.75H15.3711L13.8374 9.28467H13.1123V11.75H11.75V5.3252H13.6221ZM13.5254 6.44141H13.1123V8.17725H13.5518C14.0029 8.17725 14.3252 8.10254 14.5186 7.95312C14.7148 7.80078 14.813 7.57812 14.813 7.28516C14.813 6.98047 14.7075 6.76367 14.4966 6.63477C14.2886 6.50586 13.9648 6.44141 13.5254 6.44141Z"
        fill="#865101"
      />
    </svg>
  );
};

export default PBadge;
